import { MOBILEDEVICEWIDTH } from "config/constants";
import styled from "styled-components";
import { colours } from "styling/colours";
import { style } from "typestyle";

export const StyledTable = styled.table`
  padding: 0 30px;
  display: block;
  margin-top: 20px !important;

  tr {
    vertical-align: text-top;
    & td:first-child {
      padding-bottom: 0;
    }
  }
  td {
    font-size: 15px;
    letter-spacing: 0.09545454382896423px;
    padding-bottom: 15px;
    display: inline-block;
    word-break: break-word;

    &:first-child {
      width: 140px;
      color: ${colours.secondaryText}
    }
    &:nth-of-type(2) {
      width: 380px;
    }
  }

  td#assetDetailsDescription {
    overflow: hidden;
    word-break: break-word;
    white-space: pre-line;
  }

  @media (max-width: ${MOBILEDEVICEWIDTH}px) {
    tbody,
    td,
    tr {
      width: 100% !important;
      display: block;
    }
  }
`;

export const SeperatorStyle = style({
  width: "100%",
  background: colours.border,
  marginTop: '20px',
  height: "1px",
  padding: "0.5px 0",
})

export const infoStyle = style({
  color: colours.secondaryText,
  marginTop: "20px",
  width: "100%",
  padding: "0 30px",
  fontSize: "12px",
  display: "block",
  $nest: {
    "svg": {
      fill: colours.secondaryText
    }
  }
})

export const NoOperationSupprtStyle = style({
  color: colours.secondaryText,
  width: "100%"
})

export const assetNameStyle = style({
  fontSize: '18px'
})
export const assetTypeStyle = style({
  fontSize: '15px'
})